import { render } from "./ModalLetter.vue?vue&type=template&id=379b4baa&scoped=true"
import script from "./ModalLetter.vue?vue&type=script&lang=js"
export * from "./ModalLetter.vue?vue&type=script&lang=js"

import "./ModalLetter.vue?vue&type=style&index=0&id=379b4baa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379b4baa"]])

export default __exports__